import React, { Component } from "react";
import Select, { ValueType } from "react-select";
import { style } from "typestyle";

type OptionsDict = { [key: string]: string };
type OptionType = {
  value: string;
  label: string;
};
type Props = {
  value: string;
  options: OptionsDict;
  label?: string;
  onInputSuccess: (value: string) => void;
  disabled?: boolean;
};
export default class ActionSelectFromListOrInputValue extends Component<Props> {
  render() {
    const { value, options, label, onInputSuccess, disabled } = this.props;
    return (
      // TODO: don't do like this. Width limitation is container's responsibility
      // Components should not know about their containers
      <div className={style({ width: "50%" })}>
        <Select
          options={Object.keys(options).map(key =>
            createReactSelectOption(options, key),
          )}
          onChange={(option: ValueType<OptionType, false>) => {
            onInputSuccess((option as OptionType).value);
          }}
          value={value ? createReactSelectOption(options, value) : null}
          placeholder={label}
          isDisabled={disabled}
        />
      </div>
    );
  }
}

// We have the following model { OPTION_ID: "Option text" } (OptionsDict)
// But react-select accepts { label: "OPTION_ID", value: "Option text" }
function createReactSelectOption(
  options: OptionsDict,
  key: string,
): OptionType {
  return {
    value: key,
    label: options[key],
  };
}
